module.exports = __webpack_public_path__ + "img/fujiwara no mokou_sc2.a24349ae.png";